package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** DSL 内建对象 `date` 暴露的日期工具方法（仅作为类型标记）。 */
class DateApi private constructor() {
    companion object {
        @JvmField val INSTANCE: DateApi = DateApi()

        @JvmField val NOOP: DateApi = INSTANCE
    }
}
